import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-4" }
const _hoisted_2 = { class: "flex justify-around flex-wrap p-4" }
const _hoisted_3 = { class: "m-2 cursor-pointer" }
const _hoisted_4 = { class: "card w-60 min-h-170" }
const _hoisted_5 = { class: "card-body p-6 justify-center text-center" }
const _hoisted_6 = { class: "m-2 cursor-pointer" }
const _hoisted_7 = { class: "card w-60 min-h-170" }
const _hoisted_8 = { class: "card-body p-6 justify-center text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("h1", { class: "page-title" }, "Configurations", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: 'configure/create/custom',
              append: ""
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("div", { class: "text-gray" }, "Create Custom", -1)
              ])),
              _: 1,
              __: [0]
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_router_link, {
              to: 'configure/create/csv',
              append: ""
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createElementVNode("div", { class: "text-gray" }, "Import from CSV", -1)
              ])),
              _: 1,
              __: [1]
            })
          ])
        ])
      ])
    ])
  ]))
}